const SENTENCE_TERMINATORS = /[.!?]\s/;

export class SentenceBuffer {
  private buffer = '';

  /** Feed a text chunk. Returns any complete sentences ready for TTS. */
  push(chunk: string): string[] {
    this.buffer += chunk;
    const sentences: string[] = [];

    while (true) {
      const match = this.buffer.match(SENTENCE_TERMINATORS);
      if (match && match.index !== undefined) {
        const endIdx = match.index + match[0].length;
        sentences.push(this.buffer.slice(0, endIdx).trim());
        this.buffer = this.buffer.slice(endIdx);
        continue;
      }

      break;
    }

    return sentences;
  }

  /** Flush any remaining text. Call after the stream ends. */
  flush(): string | null {
    const remaining = this.buffer.trim();
    this.buffer = '';
    return remaining || null;
  }
}
